@if (isMulti)
{
  <div class="divisionsMultiWrapper">
    @if (unavailableStatsEntries.length > 0)
    {
      <span class="unavailableStats">
        @for (entry of unavailableStatsEntries; track entry.className; let last = $last)
        {
          <span [title]="entry.title" [class]="entry.className">{{ entry.count }} {{ entry.textKey | translate }}</span>@if (entry.className === 'complianceCount')
          {
            <a [href]="complianceUrl" target="_blank" rel="noopener" class="unavailableInfo"
               [title]="'itgen_gmr_compliance_more_info' | translate"
               [attr.aria-label]="'itgen_gmr_compliance_more_info' | translate">&#9432;</a>
          }
          @else
          {
            <span [title]="entry.title" class="unavailableInfo">&#9432;</span>
          }@if (!last) {, }
        }
      </span>
    }
    <ng-select [items]="lovRows" bindLabel="description" bindValue="code" [multiple]="true"
               [closeOnSelect]="false" [searchFn]="searchFn"
               [labelForId]="fieldId"
               [placeholder]="'itgen_gmr_select_value' | translate"
               [(ngModel)]="parameter.cfr_default_value_arr"
               (change)="onChange()" [class]="parameter.cfr_lov_preset">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <div [innerHTML]="item.description | highlight: search"></div>
      </ng-template>
    </ng-select>
    <!-- <button type="button">, not the <span> these were until 2026-08-14. They have always behaved
         as buttons - a click handler and nothing else - but as bare spans they carried no role, no
         tabindex and no accessible name, so they were unreachable by keyboard, absent from the
         accessibility tree, and could only be driven by clicking a pixel coordinate. type="button" is
         load-bearing: the default for a <button> inside a <form> is type="submit", which would turn
         "select all companies" into "download the report". -->
    <!-- The tooltip leads with the button's own visible label. Without that these two read as
         "Voeg alle Exact Online administraties toe aan de selectie." in an accessibility tree - a full
         sentence that nowhere contains the words "Alles selecteren" printed on the button, so the
         control cannot be found by what it says. Prefixing satisfies WCAG 2.2 SC 2.5.3 (Label in Name)
         whichever way a consumer resolves the precedence between contents and title, which is the point:
         the readers we drive this app with do not agree with HTML-AAM on that order. Composed from the
         same two resource codes the label and the tooltip already used, so nothing new to translate. -->
    <div class="selectionButtons">
      <button type="button" class="selectAll" [id]="'btn-select-all-' + fieldId" [title]="('itgen_gmr_select_all' | translate) + ' - ' + ('itgen_gmr_selectalltitle' | translate)" translate="itgen_gmr_select_all" (click)="selectAll()"></button>
      <button type="button" class="selectDefault" [id]="'btn-select-default-' + fieldId" [title]="('itgen_gmr_select_default' | translate) + ' - ' + ('itgen_gmr_selectdefaulttitle' | translate)" translate="itgen_gmr_select_default" (click)="selectDefault()"></button>
      <span class="selectCounterWrapper" [class.show]="(parameter.cfr_default_value_arr?.length ?? 0) > 1">
        <span class="selectCounter">{{ parameter.cfr_default_value_arr?.length }}</span><span translate="itgen_gmr_divisions_selected"></span>
      </span>
    </div>
  </div>
}
@else if (parameter.cfr_lov_preset)
{
  <ng-select [items]="lovRows" bindLabel="description" bindValue="code" [multiple]="false"
             [closeOnSelect]="true" [clearable]="true" [searchFn]="searchFn"
             [labelForId]="fieldId"
             [placeholder]="'itgen_gmr_select_value' | translate"
             [(ngModel)]="parameter.cfr_default_value"
             (change)="onChange()" [class]="parameter.cfr_lov_preset">
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div class="ui-select-header" [innerHTML]="item.description | highlight: search"></div>
    </ng-template>
  </ng-select>
}

<!-- Namespaced per report for the same reason as the field id itself: `select-division_codes` was
     identical in every report that takes a company parameter. See ai/DATAMODEL.md. The `name` stays
     the bare cfr_code - that one goes to the backend. -->
<input type="hidden" #hiddenMirror [attr.id]="'mirror-' + fieldId" [name]="parameter.cfr_code" />
